<div class="cp-page">
  <section class="cp-card">
    @if (completed) {
    <div class="cp-card__header" role="status">
      <span class="eyebrow">Contraseña actualizada</span>
      <h2>Ya puedes entrar</h2>
      <p class="subtitle">
        Tu nueva contraseña se ha guardado y todas las sesiones anteriores se
        han cerrado.
      </p>
    </div>

    <button class="submit-button" type="button" (click)="goToLogin()">
      Ir al inicio de sesión
    </button>
    } @else {
    <div class="cp-card__header">
      <span class="eyebrow">Recuperación de acceso</span>
      <h2>Crea una nueva contraseña</h2>
      @if (token) {
      <p class="subtitle">
        Elige una contraseña segura para volver a acceder a Dental RB.
      </p>
      } @else {
      <p class="subtitle">
        El enlace no es válido. Solicita uno nuevo desde el inicio de sesión.
      </p>
      }
    </div>

    @if (token) {
    <form class="cp-form" (ngSubmit)="submit()">
      <div class="form-group">
        <label for="reset-new-password">Nueva contraseña</label>
        <input
          id="reset-new-password"
          name="newPassword"
          type="password"
          autocomplete="new-password"
          [minlength]="passwordMinLength"
          maxlength="128"
          [(ngModel)]="newPassword"
          required
        />

        @if (newPassword) {
        <div class="password-meter" [attr.data-score]="passwordScore">
          <span class="password-meter__bar"></span>
          <span class="password-meter__bar"></span>
          <span class="password-meter__bar"></span>
          <span class="password-meter__bar"></span>
          <span class="password-meter__label">{{ passwordScoreLabel }}</span>
        </div>
        } @if (passwordPolicyMessage) {
        <p class="field-help field-help--error">
          {{ passwordPolicyMessage }}
        </p>
        }

        <p class="field-help">
          Mínimo {{ passwordMinLength }} caracteres. Evita contraseñas comunes y
          secuencias evidentes. Se admiten frases con espacios.
        </p>
      </div>

      <div class="form-group">
        <label for="reset-confirm-password">Repite la contraseña</label>
        <input
          id="reset-confirm-password"
          name="confirmPassword"
          type="password"
          autocomplete="new-password"
          maxlength="128"
          [(ngModel)]="confirmPassword"
          required
        />
        @if (mismatch) {
        <p class="field-help field-help--error">La confirmación no coincide.</p>
        }
      </div>

      <button class="submit-button" type="submit" [disabled]="loading">
        {{ loading ? "Guardando..." : "Guardar nueva contraseña" }}
      </button>
    </form>
    }

    <button class="link-button" type="button" (click)="goToLogin()">
      Volver al inicio de sesión
    </button>
    }
  </section>
</div>
